import axios from "axios";
import { v2MetadataUrl } from "config";
import { V2NftMetadata } from "types";

export const fetchMetadata = async (
  tokenId: number,
  cacheId?: string | null
): Promise<V2NftMetadata> => {
  const res = await axios.get<V2NftMetadata>(`${tokenId}`, {
    baseURL: v2MetadataUrl,
    params: { cacheId },
  });

  return res.data;
};
